import Color from '@tiptap/extension-color';
import { setStoredTextStyleMark } from '../../helpers/textStyleHelpers';
import { updateListMarkerColors } from '../../helpers/listStyleHelpers';

export const CustomColor = Color.extend({
  addCommands() {
    return {
      ...this.parent?.(),
      setColor:
        (color: string) =>
        ({ chain, state }) => {
          const { from, to } = state.selection;
          const isEmpty = state.selection.empty;
          return chain()
            .setMark('textStyle', { color })
            .command(({ tr }) => {
              const hadListItem = updateListMarkerColors(tr, from, to, { selectionColor: color });
              if (hadListItem && isEmpty) {
                const existingAttrs = state.selection.$from.marks().find((m) => m.type.name === 'textStyle')?.attrs ?? {};
                setStoredTextStyleMark(tr, state.schema, { ...existingAttrs, color });
              }
              return true;
            })
            .run();
        },
    };
  },
});
